export const appendAgentTokenInput = (form) => {
    const isAgent = localStorage.getItem('isAgent') === 'true';
    const orderFormToken = localStorage.getItem('orderFormToken');
    if (isAgent && orderFormToken && orderFormToken !== '') {
        const agentTokenInput = document.createElement('input');
        agentTokenInput.name = 'agent-token';
        agentTokenInput.type = 'hidden';
        agentTokenInput.value = orderFormToken;
        form.appendChild(agentTokenInput);
    }
}

export const agentLogout = () => {
    localStorage.removeItem('orderFormToken');
    localStorage.removeItem('agentUsername');
    localStorage.removeItem('expiry');
    localStorage.removeItem('agentCode');
    localStorage.setItem('isAgent', 'false'); 
}

export const isTokenValid = (expirationTimestamp) => {
    const currentTimestamp = Math.floor(Date.now() / 1000)
 
    return expirationTimestamp > currentTimestamp
}


// WEBPACK FOOTER //
// ./resources/assets/js/utils/agentUtil.js